<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="getName"
    :rules="getRules"
  >
    <div
      :class="{
        'form-group--error': errors.length,
        'form-group--required': isRequired
      }"
      class="form-group"
    >
      <label
        :for="name"
        class="form-label"
      >{{ hasLabel ? label : getName }}</label>
      <div class="form-select u-br">
        <select
          :id="name"
          v-model="model"
          :name="name"
          @change="emitSelected($event, $event.target.selectedIndex)"
        >
          <option
            :value="null"
            disabled
            selected
          >
            Select One
          </option>
          <option
            v-for="(option, value) in options"
            :key="value"
            :value="option[optionValue] || option"
          >
            {{ option[optionLabel] || option }}
          </option>
        </select>
      </div>
      <span class="form-helptext">{{ errors[0] }}</span>
    </div>
  </ValidationProvider>
</template>

<script>
import FormMixin from '@components/forms/FormMixin'

export default {
  mixins: [FormMixin],
  methods: {
    emitSelected (event, selectedIndex) {
      this.$emit('selected', this.options[selectedIndex - 1])
    },
  },
}
</script>

